/**
 * Workspace Selectors
 * Memoized selectors for the workspace Redux slice.
 *
 * Requirements: 1.2, 1.4, 1.5
 */

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { SysAppDto } from '../../services/api/sysAppService';

export const selectWorkspaceApps = (state: RootState): SysAppDto[] =>
  state.workspace.apps;

export const selectWorkspaceIsLoading = (state: RootState): boolean =>
  state.workspace.isLoading;

export const selectWorkspaceError = (state: RootState): string | null =>
  state.workspace.error;

/** Apps visible in the workspace grid — modules excluded as a client-side guard. */
export const selectVisibleWorkspaceApps = createSelector(
  [selectWorkspaceApps],
  (apps): SysAppDto[] => apps.filter((app) => app.classification !== 'module')
);

/** Whether the active tenant has a custom workspace view enabled. */
export const selectUseCustomWorkspace = (state: RootState): boolean =>
  state.workspace.useCustomWorkspace;

/** Tenant-scoped company name override (null = use global branding). */
export const selectTenantCompanyName = (state: RootState): string | null =>
  state.workspace.tenantCompanyName;
